module.exports = __webpack_public_path__ + "img/gal_17.526aa8b6.png";